export default __webpack_public_path__ + "static/char-v-48-ja-8a0e3ea02bb9291394cfe4785b07dfcb.mp4";